import { z } from 'zod'
import { mappableChannelSchema } from '../enums/source-channel.enum.js'
import { calendarDaySchema } from '../validators/temporal.validator.js'

/**
 * Where a venue's couples come from (docs/ad-attribution.spec.md): the listing
 * sites it pays for, and what each of its lead source names means.
 */

/** A listing's monthly cost from a day on, until the next cost's day. US cents. */
export const venueListingCostDtoSchema = z.object({
  monthlyCents: z.number().int().nonnegative(),
  from: calendarDaySchema,
})

export const venueListingDtoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  /** Oldest first; null for someone who doesn't see ad costs. */
  costs: z.array(venueListingCostDtoSchema).nullable(),
})

/** A lead source name the venue's leads carry, or one mapped before. */
export const venueSourceNameDtoSchema = z.object({
  /** The name as mappings know it (`sourceKey`). */
  key: z.string(),
  /** Its most common spelling. */
  name: z.string(),
  /** How many of the venue's leads carry it now. */
  leads: z.number().int().nonnegative(),
  /** What it means here; null while it isn't mapped. */
  channel: mappableChannelSchema.nullable(),
  /** The listing it means, when `channel` is `listing`. */
  listingId: z.string().uuid().nullable(),
})

export type VenueSourceNameDto = z.infer<typeof venueSourceNameDtoSchema>

export const venueSourcesDtoSchema = z.object({
  venueId: z.string().uuid(),
  listings: z.array(venueListingDtoSchema),
  /** Names not mapped yet first, then by how many leads carry them. */
  names: z.array(venueSourceNameDtoSchema),
  /** Whether listing costs are shown and saved: those with Ads View. */
  seesCosts: z.boolean(),
})

export type VenueSourcesDto = z.infer<typeof venueSourcesDtoSchema>
